<template>
  <div>
    <v-container>
      <v-row>
        <v-col md="5">
          <region-form @emitRegionData="createRegion" />
        </v-col>
        <v-col md="7">
          <v-card class="card--shadow">
            <region-list :regions="regions" />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import RegionForm from "@/components/region/RegionForm";
import RegionList from "@/components/region/RegionList";

import { mapState } from "vuex";

export default {
  components: {
    RegionList,
    RegionForm,
  },
  computed: {
    ...mapState("Region", ["regions"]),
  },
  methods: {
    createRegion(data) {
      this.$store.dispatch("Region/createRegion", data);
    },
  },
  created() {
    this.$store.dispatch("Region/getRegions");
  },
};
</script>

<style scoped>
.card--shadow {
  box-shadow: var(--primary-box-shadow) !important;
}
</style>
